import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { serviceManagementFeature, ServiceManagementEffects } from './store';

export function provideServiceManagementFeature(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(serviceManagementFeature),
    provideEffects(ServiceManagementEffects),
  ]);
}
